import React, { useState } from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Result from 'antd/lib/result';
import Avatar from 'antd/lib/avatar';
import { changePassword } from 'parity-network-requests';
import { useHistory } from 'react-router-dom';
import { config } from '../../../../config';

import './ChangePassword.less';

const { REACT_APP_BUILD_ENV } = config;

export const ChangePassword = (props) => {
  const { theme } = props;
  const user = JSON.parse(localStorage.getItem('current_user'));
  const { first_name: firstName, last_name: lastName } = user;
  const displayName = `${firstName[0]}${lastName[0]}`;
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [apiResponse, setApiReponse] = useState('');
  const history = useHistory();

  const submitPasswordChange = async () => {
    const response = await changePassword(REACT_APP_BUILD_ENV, currentPassword, newPassword1, newPassword2);
    if (response === 200) {
      setApiReponse('success');
    } else {
      setApiReponse(`${response}`);
    }
  };

  return (
    <div className={`change-password change-password-${theme}`}>
      <div className="change-password-card">
        <div className="change-password-card__header">
          <div className="change-password-card__title">Change Password</div>
        </div>
        <div className="change-password-card__body">
          <div className="change-password-card__profile-photo-section">
            <div className="change-password-card__profile-photo">
              <Avatar
                className="change-password-profile-img"
                alt="profile icon"
                style={{ backgroundColor: user.avatar_color || '#ffffff' }}
              >
                {displayName}
              </Avatar>
            </div>
            <div className="change-password-card__profile-photo-info">
              <div className="change-password-card__user-name">{`${firstName} ${lastName}`}</div>
            </div>
          </div>
          {apiResponse ? (
            <div className="change-password__result">
              {apiResponse === 'success' ? (
                <Result
                  status="success"
                  title="Your password was successfully updated!"
                  extra={[
                    <Button
                      onClick={() => {
                        setApiReponse('');
                        history.goBack();
                      }}
                      key="reset"
                    >
                      Go to homepage
                    </Button>,
                  ]}
                />
              ) : (
                <Result
                  status="error"
                  title="Oops! There was a problem updating your password"
                  subTitle={`Error: ${apiResponse}`}
                  extra={[
                    <Button onClick={() => setApiReponse('')} key="retry">
                      Try Again
                    </Button>,
                  ]}
                />
              )}
            </div>
          ) : (
            <Form
              layout="vertical"
              className={`change-password__form app-form-${theme}`}
              onFinish={() => {
                submitPasswordChange();
              }}
            >
              <Form.Item
                name="current password"
                label="Enter Current Password"
                className="change-password__input-wrapper"
                rules={[
                  {
                    required: true,
                    message: 'Please enter your current password',
                  },
                ]}
                hasFeedback
              >
                <Input.Password
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  size="large"
                  className="change-password__input"
                />
              </Form.Item>
              <Form.Item
                name="new password"
                label="Enter New Password"
                className="change-password__input-wrapper"
                rules={[
                  {
                    required: true,
                    message: 'Please enter your new password',
                  },
                ]}
                hasFeedback
              >
                <Input.Password
                  value={newPassword1}
                  onChange={(e) => setNewPassword1(e.target.value)}
                  size="large"
                  className="change-password__input"
                />
              </Form.Item>
              <Form.Item
                name="confirm new password"
                label="Confirm New Password"
                dependencies={['new password']}
                className="change-password__input-wrapper"
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your new password again',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('new password') === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject('The two passwords you entered do not match');
                    },
                  }),
                ]}
                hasFeedback
              >
                <Input.Password
                  value={newPassword2}
                  onChange={(e) => setNewPassword2(e.target.value)}
                  size="large"
                  className="change-password__input"
                />
              </Form.Item>
              <div className="change-password__button-wrapper">
                <Button block htmlType="submit" size="large" className="change-password__button">
                  <div className="change-password__button-text">Change Password</div>
                </Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};
